// extracted by mini-css-extract-plugin
export var pagination = "post-module--pagination--Y3rfk";
export var postMeta = "post-module--post-meta--b8vC1";